function setInitialStep(step) {
    console.log(`Setting initial step to: ${step}`);
    const steps = ['step1', 'step2', 'confirmationMessage'];
    const timelineSteps = document.querySelectorAll('.timeline li');
    const stepsWrapper = document.querySelector('.steps-wrapper');

    steps.forEach((stepId, index) => {
        const stepElement = document.getElementById(stepId);
        if (stepElement) {
            stepElement.classList.remove('active', 'exiting');
            stepElement.style.display = 'none';
            console.log(`Step ${stepId} deactivated`);
        }
        if (timelineSteps[index]) {
            timelineSteps[index].classList.remove('active');
        }
    });

    if (step >= 1 && step <= steps.length) {
        const stepElement = document.getElementById(steps[step - 1]);
        if (stepElement) {
            stepElement.style.display = 'block';
            setTimeout(() => {
                stepElement.classList.add('active');
                stepElement.classList.remove('exiting');
                adjustStepsWrapperHeight(stepElement);
                console.log(`Step ${steps[step - 1]} activated`);
                if (steps[step - 1] === 'step2') {
                    setTimeout(() => {
                        const cityOrComunaElement = document.getElementById('cityOrComuna');
                        if (cityOrComunaElement) {
                            cityOrComunaElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            setTimeout(() => {
                                cityOrComunaElement.focus();
                                console.log('Scrolled to and focused on #cityOrComuna element');
                            }, 500);
                        } else {
                            console.log('Element #cityOrComuna not found');
                        }
                    }, 400);
                }
            }, 10);
        }
        if (timelineSteps[step - 1]) {
            timelineSteps[step - 1].classList.add('active');
        }
    }

    if (step === 2) {
        showClinicSelection();
    }
}

function adjustStepsWrapperHeight(stepElement) {
    const stepsWrapper = document.querySelector('.steps-wrapper');
    if (stepElement && stepsWrapper) {
        console.log(`Adjusted steps wrapper height to: ${stepElement.offsetHeight}px`);
    }
}

function showClinicSelection() {
    console.log('Showing clinic selection');
    document.getElementById('clinic-selection').style.display = 'block';
    document.getElementById('calendar-container').style.display = 'none';
    adjustStepsWrapperHeight(document.getElementById('step2'));
}

function showCalendar() {
    console.log('Showing calendar');
    console.log('Hiding clinic-selection');
    document.getElementById('clinic-selection').style.display = 'none';
    console.log('Showing calendar-container');
    document.getElementById('calendar-container').style.display = 'block';
    console.log('Adjusting steps wrapper height');
    adjustStepsWrapperHeight(document.getElementById('step2'));

    const selectedClinicCalendarDiv = document.getElementById('selectedClinicCalendar');
    console.log('Setting innerHTML for selectedClinicCalendarDiv');
    selectedClinicCalendarDiv.innerHTML = `<i class="fas fa-map-marker-alt" style="color:#c08891"></i><br>Reserva tu próxima sesión de regalo en: <b>${collectedData.clinic.name}</b> <span>${collectedData.clinic.address}</span>`;
    console.log('Showing selectedClinicCalendarDiv');
    selectedClinicCalendarDiv.style.display = 'block';

    console.log("collectedData en showCalendar: ", collectedData);
    console.log("Clinic name: ", collectedData.clinic.name);
    console.log("Clinic address: ", collectedData.clinic.address);
}

function editClinicSelection() {
    console.log('Editing clinic selection');
    document.getElementById('calendar-container').style.display = 'none';
    document.getElementById('clinic-selection').style.display = 'block';
    adjustStepsWrapperHeight(document.getElementById('step2'));
    document.querySelector('.timeline li:nth-child(2)').classList.add('active');
    document.querySelector('.timeline li:nth-child(3)').classList.remove('active');
    
    const inputField = document.getElementById('cityOrComuna');
    inputField.style.display = 'block';
    inputField.value = '';
    document.getElementById('clinicList').style.display = 'block';
    document.getElementById('clinicList').innerHTML = '';
    document.getElementById('selectedClinic').innerHTML = '';
    document.getElementById('selectedClinicCalendar').style.display = 'none';
}

let isRequestInProgress = false;

function toggleFormState(isLoading) {
    const form = document.getElementById('inscriptionForm');
    const inputs = form.querySelectorAll('input, select, button');
    const continueButton = document.getElementById('continueButton');

    if (isLoading) {
        inputs.forEach(input => input.disabled = true);
        continueButton.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Cargando...';
    } else {
        inputs.forEach(input => input.disabled = false);
        continueButton.innerHTML = 'Continuar';
    }
}

function handleNextStep() {
    console.log('Handling next step');
    const submitButton = document.getElementById('continueButton');
    if (!submitButton.disabled && submitForm()) {
        console.log('Form is valid, proceeding to next step');
        toggleFormState(true);
        goToNextStep();
        const cityOrComunaElement = document.getElementById('cityOrComuna');
        if (cityOrComunaElement) {
            cityOrComunaElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    } else {
        console.log('Form is invalid or submit button is disabled');
        toggleFormState(false);
    }
}

function goToNextStep() {
    const currentStep = document.querySelector('.timeline li.active');
    const nextStepIndex = Array.from(currentStep.parentNode.children).indexOf(currentStep) + 1;
    console.log(`Current step index: ${nextStepIndex - 1}, next step index: ${nextStepIndex}`);
    if (nextStepIndex < 3) {
        setInitialStep(nextStepIndex + 1);
    } else {
        setInitialStep(3);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    console.log('Initializing first step');
    setInitialStep(1);
});
